<template>
  <div class=" is-fullwidth">
    <div class="level">
        <div class="level-left">
          <div class="columns" >
              

             <div class=" col ">
               <input type="date" class="input" v-model="start_date" :disabled="this.orders_loading==true"/>
                
              </div>
              <div class=" col ml-2" >
               <input type="date" class="input" v-model="end_date" :disabled="this.orders_loading==true"/>
                
              </div>
               <div class=" col ml-2" >
                <button class="button is-info" @click="resetDates()" :disabled="this.orders_loading==true">Reset Dates (7 Days)</button>
                
              </div>

              
            </div>
      </div>
        
      </div>
    
   <div class="tabs is-boxed">
        <ul>
            <li v-bind:class="{'is-active': tab === 'results' }" @click="tab='results'"><a>Results</a></li>
           <li v-bind:class="{'is-active': tab === 'orders' }" @click="tab='orders'"><a>Orders</a></li>
           
        </ul>
    </div>

    <div v-if="tab ==='results'">
        <p v-if="orders_loading===true">Loading ...</p>
        <div v-if="orders_loading===false">
            <p>Total Orders Finished In Time Period : <strong>{{ orders.length }}</strong> ( {{ total_order_qty }} garments)</p>
            <br />
            <table class="table is-hoverable is-fullwidth" id="ordersfinished" >
                <thead>
                    <tr>
                <th width="50%">Artworker</th>
                <th>Number of Orders</th>
                <th>Total Garments</th>
                
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in users" :key="row.id">
                        <td><span @click="viewArtworkerOrders(row.id)">{{ row.name }}</span></td>
                        <td>{{ row.counter }}</td>
                        <td>{{ row.total_qtys }}</td>
                        </tr>
                </tbody>
                </table>

                <br />
            <table class="table is-hoverable is-fullwidth" id="quantities" >
                <thead>
                    <tr>
                <th width="50%">Qty</th>
                <th>Number of Orders</th>
                <th>Total Garments</th>
                
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in orderQtys" :key="row.id">
                        <td>{{ row.label }}</td>
                        <td>{{ row.counter }}</td>
                        <td>{{ row.total_order_qty }}</td>
                        </tr>
                </tbody>
                </table>

              <br />
            <table class="table is-hoverable is-fullwidth" id="turnarounds" >
                <thead>
                    <tr>
                <th width="50%">Turnaround Days</th>
                <th>Number of Orders</th>
                <th>Total Garments</th>
                
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in days" :key="row.id">
                        <td>{{ row.label }}</td>
                        <td>{{ row.counter }}</td>
                        <td>{{ row.total_qtys }}</td>
                        </tr>
                </tbody>
                </table>
                <em>This is calculated from the date receipted until the day the artworker marked the job as finished, excluding weekends</em>

                

        </div>
        <button @click="exportResultsXLS()" class="button is-info mt-4" v-if="orders_loading==false" >Export to Excel</button>
        
    </div>

    <div v-if="tab === 'orders'">
        <div class="select is-pulled-right">
            <select  v-model="selected_artworker_user_id">
                  <option value="">Filter By Artworker</option>
                  <option v-bind:value="row.id" v-for="row in users" :key="row.id">{{ row.name }}</option>
                  
          </select>
          </div>
        <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable" >
            <thead>
                <tr>
            <th>PO Number</th>
            <th>Customer</th>
            <th>Garment</th>
            <th>Qty</th>
            <th>Design</th>
            <th>Date Finished</th>
            <th>Designer</th>
            <th>Days</th>
            <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="orders_loading===true">
            <td colspan="7"><strong>Loading orders ...</strong></td>
            </tr>
            <tr v-for="(order, index) in filteredOrders" v-bind:key="index" v-show="orders_loading===false">
            <td >{{order.ponumber}}</td>
            <td>{{order.clientname}}</td>
            <td>{{order.garmentname}}</td>
            <td>{{order.total_qty}}</td>
            <td>{{order.designname}}</td>
            <td>{{order.date}}</td>
            <td>{{ order.firstname }} {{ order.surname }}</td>
            <td>{{order.turnaroundTime}}</td>
            <td>
                <a :href="VUE_APP_ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-info is-small">View</button></a>
            </td>
            
                
                
                </tr>
        </tbody>
        
        </table>
        <button @click="exportOrdersXLS()" class="button is-info mt-4" v-if="orders_loading==false" >Export to Excel</button>

        
    </div>

     
    
  </div>
</template>

<script>

import OrderService from '@/services/OrderService.js';
//import SalesService from '@/services/SalesService.js';
import XLSX from 'xlsx';

export default {
  name:'ArtworkFinishedReport',
  components: {
   	
  },
  data() {
    return {
      client_id: '',
       clients: [],
      orders: [],
       selected_artworker_user_id: '',
      username: '',
      start_date: '',
        end_date: '',
      currentSort: 'count',
      currentSortDir: 'desc',
      
     accessToken: '',
     orders_loading:true,
     VUE_APP_ASP_URL:process.env.VUE_APP_ASP_URL,
     tab : 'results',
     ignoreWatchers: false
    

     
    }
  },
  created() {
      this.getAccessToken()
        .then(() => { 
            this.getArtworksFinished()
        });
      
    },
  methods: {
    async getAccessToken() {
        this.accessToken = await this.$auth.getTokenSilently()
    },
    exportResultsXLS() {
		 var wb = XLSX.utils.book_new();
     
     wb.SheetNames.push("Orders Finished");
		 var ws1 = XLSX.utils.table_to_sheet(document.getElementById('ordersfinished'));
     wb.Sheets["Orders Finished"] = ws1;

     wb.SheetNames.push("Quantities");
		 var ws2 = XLSX.utils.table_to_sheet(document.getElementById('quantities'));
     wb.Sheets["Quantities"] = ws2;

     wb.SheetNames.push("Turnarounds");
		 var ws3 = XLSX.utils.table_to_sheet(document.getElementById('turnarounds'));
     wb.Sheets["Turnarounds"] = ws3;


		 XLSX.writeFile(wb, 'Artworks Finished Report.xlsx')

	 },
   exportOrdersXLS() {
		 var wb = XLSX.utils.book_new();
     
     wb.SheetNames.push("Orders");
		 var ws1 = XLSX.utils.table_to_sheet(document.getElementById('orderstable'));
     wb.Sheets["Orders"] = ws1;

    

		 XLSX.writeFile(wb, 'Artworks Finished Orders.xlsx')

	 },
   
    async getArtworksFinished() {
      this.orders_loading=true;
      this.orders = [];
      OrderService.getArtworksFinished(this.accessToken, this.start_date, this.end_date)
          .then((orders) => {
            this.$set(this, "orders", orders);
          })
          .catch((error) => {
            if (error.response && error.response.status === 500) {
              console.error("Server error (500)");
              // Optional: show message to user
              this.$set(this, "orders", []);
              alert("A server error occurred. Please try again. The date range is possibly too large.");
            } else {
              console.error("Request failed:", error);
            }
          })
          .finally(() => {
            this.orders_loading = false;
          });
    },
    
    getStartDate() {
            
            var d = new Date();
            
            d.setDate(d.getDate() - 7);
            return d.toISOString().slice(0,10);
             
    },
    viewArtworkerOrders(user_id)
    {
        this.selected_artworker_user_id=user_id
        this.tab = 'orders'
    },
    resetDates() {
      this.ignoreWatchers = true;
      this.start_date = this.getStartDate();
      this.end_date = new Date().toISOString().slice(0,10);
      this.ignoreWatchers = false;
      this.getArtworksFinished();
    }

   
  },
  computed : {
     total_order_qty() {
        let total = this.orders.reduce(function (previousValue, currentValue) {
          return previousValue + currentValue.total_qty;
        }, 0);

        return total;
     },
     users() {
         let filteredUsers = []

         this.orders.forEach(order => {      
            
            let user = filteredUsers.find(user => user.id === order.userID);
            if(user)
            {
                user.counter++
                user.total_qtys += order.total_qty
            }
            else{
                let thisUser = {'id' : order.userID, 'name' : order.firstname + ' ' + order.surname, 'counter' : 1, "total_qtys" : order.total_qty}
                filteredUsers.push(thisUser)
            }
            
        });

         return filteredUsers
     },
     days() {
         let filteredDays = []

         this.orders.forEach(order => {      
            
            let day = filteredDays.find(day => day.label === order.turnaroundTime);
            if(day)
            {
                day.counter++
                day.total_qtys += order.total_qty
            }
            else{
                let thisDay = {'label' : order.turnaroundTime, 'counter' : 1, "total_qtys" : order.total_qty}
                filteredDays.push(thisDay)
            }
            
        });

        filteredDays = filteredDays.sort((c1, c2) => (c1.label > c2.label) ? 1 : (c1.label < c2.label) ? -1 : 0);

         return filteredDays
     },
     orderQtys: function () {
       let quantityObject = []

       this.orders.forEach(order => {    
            let thisLabel = "Unknown"
            let thisId = 0
            if(order.total_qty === 1)
            {
              thisLabel = 1
              thisId = 1
            }
            else if(order.total_qty === 2)
            {
              thisLabel = 2
              thisId = 2
            }
            else if(order.total_qty <= 5)
            {
              thisLabel = "<= 5"
              thisId = 3
            }
            else if(order.total_qty <= 10)
            {
              thisLabel = "<= 10"
              thisId = 4
            }
            else if(order.total_qty >10 && order.total_qty <=50)
            {
              thisLabel = "11-50"
              thisId = 5
            }
            else if(order.total_qty >50 && order.total_qty <=100)
            {
              thisLabel = "51-100"
              thisId = 6
            }
            else if(order.total_qty >100)
            {
              thisLabel = "> 100"
              thisId = 7
            }
            
            let quantity = quantityObject.find(quantity => quantity.label === thisLabel);
            if(quantity)
            {
                quantity.counter++
                quantity.total_order_qty += order.total_qty
            }
            else{
                let thisQuantity = {'id' : thisId, 'label' : thisLabel,  'counter' : 1, 'total_order_qty': order.total_qty}
                quantityObject.push(thisQuantity)
            }
            
        });

        let sortedQuantities = quantityObject.sort((c1, c2) => (c1.id > c2.id) ? 1 : (c1.id < c2.id) ? -1 : 0);

       return sortedQuantities
     },
     filteredOrders: function () {
       let filteredOrders = []

        if(this.selected_artworker_user_id != "")
          {
            filteredOrders = this.orders.filter(row => row.user_id === this.selected_artworker_user_id)
          }
          else
          {
              filteredOrders = this.orders
          }

          return filteredOrders
       
     },
     
  },

 
  mounted() {
    if (localStorage.artworks_finished_report_start_date) {
      this.start_date = localStorage.artworks_finished_report_start_date;
    }
    else{
      this.start_date = this.getStartDate()
    }

     if (localStorage.artworks_finished_report_end_date) {
      this.end_date = localStorage.artworks_finished_report_end_date;
    }
    else{
      this.end_date = new Date().toISOString().slice(0,10)
    }

    
  },
  watch: {
   
    start_date: function () {
      if (this.ignoreWatchers) return; // skip watcher
     localStorage.artworks_finished_report_start_date = this.start_date;
      this.getArtworksFinished()
    },
    end_date: function () {
      if (this.ignoreWatchers) return; // skip watcher
     localStorage.artworks_finished_report_end_date = this.end_date;
      this.getArtworksFinished()
    },
  }
}



</script>


